import React from 'react'
import { Wrapper } from './Style'

export const InnerFormTextWrapper = ({ children }) => (
  <Wrapper>{children}</Wrapper>
)
